import { alphaNumSort } from '@shared/utils/utils-sort';

/*
 * Takes array of logpoints and returns multiple lines to be drawn on map
 * lines are sorted as defined in https://infrakit.atlassian.net/wiki/spaces/ERD/pages/394330124/Log+point+metadata+specification
 * logpoints need to have .source property set before calling this method
 */
function sortLogpoints(logpoints: ILogpoint[]): ILogpoint[][] {
    // Group the points by source at this phase already to eliminate lines that span across points from different sources
    const byLinecodeAndVehicle: ILogpoint[][] = _.values(_.groupBy(logpoints, l => l.linecode + '_' + (l.vehicleId || '') + '_' + l.loadSource));

    return byLinecodeAndVehicle.map(line => {
        const withNumber: ILogpoint[] = [];
        const withTimestamp: ILogpoint[] = [];
        const withOrdinal: ILogpoint[] = [];

        for (const point of line) {
            if (point.number?.length) withNumber.push(point);
            else if (point.timestamp) withTimestamp.push(point);
            else withOrdinal.push(point);
        }

        const lineSorted = [
            ...withNumber.sort((a, b) => alphaNumSort(a.number, b.number)),
            ...withTimestamp.sort((a, b) => a.timestamp - b.timestamp),
            ...withOrdinal.sort((a, b) => a.ordinalInSource - b.ordinalInSource)
        ];

        return lineSorted
    }).sort((lineA, lineB) => {
        const lineAStart = minTimestampForLogpoints(lineA);
        const lineBStart = minTimestampForLogpoints(lineB);
        return lineAStart - lineBStart;
    });
}

function getLoadSourceAsString(source: FeatureSource): string {
    if (source.modelId) {
        return 'modelId_' + source.modelId;
    }
    else if (source.alignmentId) {
        return 'alignmentId_' + source.alignmentId;
    }
    else if (source.folderId) {
        return 'folderId_' + source.folderId;
    }
    else if (source.documentId) {
        return 'documentId_' + source.documentId;
    }
    else if (source.vehicleId) {
        return 'vehicleId_' + source.vehicleId;
    }

    return '';
}

function minTimestampForLogpoints(logpoints: ILogpoint[]) {
    return Math.min(...logpoints.map(l => l.timestamp));
}

export const LogpointsLinecodeService = {
    sortLogpoints,
    getLoadSourceAsString
};
